/**
 * Payments Service - получение курсов и создание платежа
 */

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export const paymentsService = {
    getCourses: async () => {
        return apiClient.get(ENDPOINTS.PAYMENTS.GET_COURSES, {}, true);
    },

    addPayment: async (payload) => {
        return apiClient.post(
            ENDPOINTS.PAYMENTS.ADD_PAYMENT,
            payload,
            true,
            false,
        );
    },
};

export default paymentsService;
